export const enum DOC_TYPE {
	INVOICE = 'invoice',
	ESTIMATE = 'estimate',
	EXPENSES = 'expenses'
}

export enum TEMPLATE_TAB_TYPE {
	STYLE = 'style',
	DATA = 'data'
	// DATA2 = 'data2'
}

